export const getInitialBoolean = (key: string, def: boolean): boolean => {
  const val = localStorage.getItem(key);
  return val === null ? true : val === 'true';
};
export const getInitialNumber = (key: string, def: number): number => {
  const val = localStorage.getItem(key);
  return val === null ? def : Number(val);
};
export const getInitialString = (key: string, def: string): string => {
  const val = localStorage.getItem(key);
  return val === null ? '' : val;
};